import { z } from "zod";

export enum EAppointmentCancellationReasonType {
  DEFINITIVE = "DEFINITIVE",
  TEMP_SOON = "TEMP_SOON",
  TEMP_MONTH = "TEMP_MONTH",
  UPDATE = "UPDATE",
}

export const appointmentCancellationReasonTypeSchema = z.object({
  id: z.number(),
  reason: z.nativeEnum(EAppointmentCancellationReasonType),
});

export const AppointmentUpdateReasonTypes = {
  [EAppointmentCancellationReasonType.UPDATE]: {
    id: 4,
    reason: EAppointmentCancellationReasonType.UPDATE,
  },
};

export const AppointmentCancellationReasonTypes = {
  [EAppointmentCancellationReasonType.DEFINITIVE]: {
    id: 1,
    reason: EAppointmentCancellationReasonType.DEFINITIVE,
  },
  [EAppointmentCancellationReasonType.TEMP_SOON]: {
    id: 2,
    reason: EAppointmentCancellationReasonType.TEMP_SOON,
  },
  [EAppointmentCancellationReasonType.TEMP_MONTH]: {
    id: 3,
    reason: EAppointmentCancellationReasonType.TEMP_MONTH,
  },
} as const;
